module.exports = __webpack_public_path__ + "static/media/instagram.fa07de6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/instagram.svg
// module id = 245
// module chunks = 0